import { ModelFactory } from "@shared/factories/model.factory";
import { ItemToVerifyType} from "@generated/graphql";
import { ItemToVerify } from "../models/item-to-verify.model";

export class ItemToVerifyFactory extends ModelFactory<ItemToVerifyType, ItemToVerify> {
  create (state: ItemToVerifyType): ItemToVerify {
   return new ItemToVerify(state)
  }

  fake (): ItemToVerify {
    throw new Error('This method is not implemented')
  }
}

export const itemToVerifyFactory = new ItemToVerifyFactory()
